import request from './request'

export function listLaborSettle(data) {
  return request.post('/production/labor-settles/list', data)
}
